import React, { useState, useEffect, useRef } from 'react';
import Input from '../common/Input';
import Button from '../common/Button';
import Checkbox from '../common/Checkbox';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';

const ProductForm = ({
  initialData,
  categories,
  brands,
  loading,
  submitting,
  onSubmit,
  submitButtonText = 'Save Product',
  isEdit = false,
  onFetchModels,
  availableModels = [],
  onAddCategory, // New prop for adding categories
  onAddBrand, // New prop for adding brands
    isMainAdmin = false,  // ADD THIS
}) => {
  const [formData, setFormData] = useState(initialData || {});
  const [errors, setErrors] = useState({});
  const [imageFiles, setImageFiles] = useState([]);
  const [imagePreviewUrls, setImagePreviewUrls] = useState([]);
  const [removedImageIndexes, setRemovedImageIndexes] = useState([]);
  const [specifications, setSpecifications] = useState(initialData?.specifications || []);
  const [modelCompatibility, setModelCompatibility] = useState(initialData?.modelCompatibility || []);
  const [categorySearch, setCategorySearch] = useState('');
  const [filteredCategories, setFilteredCategories] = useState([]);



  // Main Admin Features
const [enableAdminMode, setEnableAdminMode] = useState(false);
const [vehicleSearch, setVehicleSearch] = useState('');
const [vehicleSearchResults, setVehicleSearchResults] = useState([]);
const [isSearchingVehicle, setIsSearchingVehicle] = useState(false);
const [showVehicleResults, setShowVehicleResults] = useState(false);
const [vehicleNumber, setVehicleNumber] = useState(initialData?.vehicleNumber || '');


  // Brand search states - NEW
const [brandSearch, setBrandSearch] = useState('');
const [filteredBrands, setFilteredBrands] = useState([]);


  // Barcode states - simplified
  const [generatedBarcode, setGeneratedBarcode] = useState('');

  // Category and Brand modal states
  const [showAddCategoryModal, setShowAddCategoryModal] = useState(false);
  const [showAddBrandModal, setShowAddBrandModal] = useState(false);
  const [newCategory, setNewCategory] = useState({ name: '', description: '', image: null });
  const [newBrand, setNewBrand] = useState({ name: '', description: '', logo: null, website: '' });

  // Product name search states
  const [productNameSearch, setProductNameSearch] = useState('');
  const [showProductSuggestions, setShowProductSuggestions] = useState(false);
  const [productSuggestions, setProductSuggestions] = useState([]);
  const productSearchRef = useRef(null);

  // Model compatibility search states
  const [modelSearch, setModelSearch] = useState('');
  const [showModelSuggestions, setShowModelSuggestions] = useState(false);
  const [modelSuggestions, setModelSuggestions] = useState([]);
  const [activeModelIndex, setActiveModelIndex] = useState(null);
  const modelSearchRef = useRef(null);
  const [computedAvailableModels, setComputedAvailableModels] = useState([]);
  const [modelsLoading, setModelsLoading] = useState(false);

  // Common bike parts suggestions for search
  const commonBikePartNames = [
    'Brake Pads', 'Brake Shoes', 'Brake Cable', 'Brake Lever', 'Brake Disc',
    'Engine Oil', 'Oil Filter', 'Air Filter', 'Fuel Filter', 'Spark Plug',
    'Battery', 'Headlight Bulb', 'Tail Light Bulb', 'Indicator Bulb', 'Horn',
    'Chain', 'Chain Sprocket', 'Clutch Plate', 'Clutch Cable', 'Accelerator Cable',
    'Shock Absorber', 'Fork Oil', 'Suspension Spring', 'Wheel Bearing', 'Ball Bearing',
    'Piston', 'Piston Ring', 'Cylinder Head', 'Valve', 'Carburetor',
    'Fuel Pump', 'Fuel Tank', 'Petrol Tank Cap', 'Side Mirror', 'Handle Grip',
    'Seat Cover', 'Foot Rest', 'Kick Start', 'Self Start Motor', 'Wiring Harness',
    'CDI Unit', 'Coil', 'Rectifier', 'Regulator', 'Speedometer Cable',
    'Tyre', 'Tube', 'Rim', 'Spoke', 'Hub Cap',
    'Silencer', 'Exhaust Pipe', 'Muffler', 'Radiator', 'Coolant',
    'Mudguard', 'Number Plate', 'Tool Kit', 'Side Stand', 'Main Stand'
  ];

  // Brand name mapping
  const brandNameMapping = {
    // Indian Brands - Match your Firebase data
    'bajaj': 'bajaj',
    'hero motocorp': 'hero',
    'tvs motor': 'tvs',
    'royal enfield': 'royalenfield',
    'mahindra two wheelers': 'mahindra',
    'ola electric': 'ola',
    'ather energy': 'ather',
    'revolt motors': 'revolt',
    'lml': 'lml',
    'kinetic engineering': 'kinetic',

    // Japanese Brands
    'honda': 'honda',
    'yamaha': 'yamaha',
    'suzuki': 'suzuki',
    'kawasaki': 'kawasaki',

    // European Brands
    'ktm': 'ktm',
    'ducati': 'ducati',
    'bmw motorrad': 'bmw',
    'triumph': 'triumph',
    'aprilia': 'aprilia',
    'piaggio': 'piaggio',
    'vespa': 'vespa',
    'husqvarna': 'husqvarna',
    'moto guzzi': 'moto_guzzi',
    'beta motor': 'beta',
    'gasgas': 'gasgas',

    // American Brands
    'harley-davidson': 'harley',
    'indian motorcycle': 'indian',
    'zero motorcycles': 'zero',

    // Chinese Brands
    'cfmoto': 'cfmoto',
    'benelli (qj motor)': 'benelli',
    'keeway': 'keeway',
    'zongshen': 'zongshen',
    'lifan': 'lifan',
    'haojue (suzuki joint venture)': 'haojue',

    // Korean Brands
    'hyosung': 'hyosung',
    'daelim': 'daelim',

    // Other Brands
    'gpx racing': 'gpr',
    'modenas': 'modenas',
    'vinfast': 'vinfast',
    'kymco': 'kymco',
    'sym': 'sym',
    'gogoro': 'gogoro',
    'shineray': 'shineray',
    'energica': 'energica',
    'lightning motorcycles': 'lightning',
    'cake': 'cake',

    // Universal
    'generic/universal parts': 'generic',
    'oem parts': 'oem',
    'aftermarket parts': 'aftermarket'
  };



  const bikeModels = {
    // Indian Bike Brands - Expanded
    Bajaj: [
      // Pulsar Series
      'Pulsar 125', 'Pulsar 135 LS', 'Pulsar 150', 'Pulsar 150 Twin Disc', 'Pulsar 180',
      'Pulsar 200 NS', 'Pulsar 220F', 'Pulsar RS200', 'Pulsar AS 150', 'Pulsar AS 200',
      'Pulsar N250', 'Pulsar F250', 'Pulsar N160',
      // Platina Series
      'Platina 100', 'Platina 100 ES', 'Platina 110', 'Platina 110 H-Gear',
      // Discover Series
      'Discover 100', 'Discover 110', 'Discover 125', 'Discover 125 ST', 'Discover 150', 'Discover 150F',
      // Avenger Series
      'Avenger 160', 'Avenger 220', 'Avenger Street 160', 'Avenger Street 220', 'Avenger Cruise 220',
      // Dominar Series
      'Dominar 250', 'Dominar 400', 'Dominar 400 UG',
      // Commuter Series
      'CT 100', 'CT 110', 'CT 125X',
      // Legacy Models
      'XCD 125', 'XCD 135', 'Caliber 115', 'Wind 125', 'Boxer 150'
    ],

    Hero: [
      // Splendor Series
      'Splendor Plus', 'Splendor Plus XTEC', 'Splendor iSmart', 'Splendor iSmart 110', 'Super Splendor',
      // HF Series
      'HF Deluxe', 'HF Deluxe i3S', 'HF Dawn', 'HF 100',
      // Passion Series
      'Passion Pro', 'Passion Pro i3S', 'Passion XPro', 'Passion Plus',
      // Glamour Series
      'Glamour', 'Glamour Fi', 'Glamour XTEC', 'Glamour i3S',
      // Xtreme Series
      'Xtreme 160R', 'Xtreme 200S', 'Xtreme 200R', 'Xtreme Sports',
      // Karizma Series
      'Karizma', 'Karizma R', 'Karizma ZMR', 'Karizma XMR',
      // Scooters
      'Maestro Edge', 'Maestro Edge 110', 'Maestro Edge 125', 'Destini 125', 'Pleasure Plus',
      'Duet', 'Duet 110',
      // Electric
      'Vida V1'
    ],
    tvs: [
      // Apache Series
      'Apache RTR 160', 'Apache RTR 160 2V', 'Apache RTR 160 4V', 'Apache RTR 180',
      'Apache RTR 200 4V', 'Apache RTR 310', 'Apache RR 310', 'Apache RR 99',
      // Commuter Series
      'Star City Plus', 'Radeon', 'Sport', 'Phoenix 125', 'Raider 125',
      'Victor GL', 'Max 125', 'Flame DS 125', 'Flame SR 125',
      // Scooters
      'Jupiter', 'Jupiter Classic', 'Jupiter 110', 'Jupiter 125', 'Ntorq 125', 'Ntorq 125 Race Edition',
      'Scooty Pep+', 'Scooty Zest 110', 'Wego',
      // Electric
      'iQube Electric', 'iQube S'
    ],
    royalenfield: [
      // Classic Series
      'Classic 350', 'Classic 500', 'Classic Chrome', 'Classic Desert Storm', 'Classic Battle Green',
      'Classic Stealth Black', 'Classic Redditch', 'Classic Signals',
      // Bullet Series
      'Bullet 350', 'Bullet 500', 'Bullet Electra', 'Bullet Standard',
      // Thunderbird Series
      'Thunderbird 350', 'Thunderbird 350X', 'Thunderbird 500', 'Thunderbird 500X',
      // Adventure Series
      'Versys 650', 'Versys 1000', 'Versys-X 300',
      // W Series
      'W800', 'W650',
      // Classic Models
      'Eliminator', 'Vulcan S'
    ],
    // European Brands - Expanded
    ktm: [
      // Duke Series
      'Duke 125', 'Duke 200', 'Duke 250', 'Duke 390', 'Duke 790', 'Duke 890', 'Duke 1290',
      // RC Series
      'RC 125', 'RC 200', 'RC 390', 'RC 8C',
      // Adventure Series
      'Adventure 250', 'Adventure 390', 'Adventure 790', 'Adventure 890', 'Adventure 1090', 'Adventure 1290',
      // Enduro Series
      'Enduro R 690', 'Enduro R 790',
      // SMC Series
      'SMC R 690'
    ],
    ducati: [
      // Panigale Series
      'Panigale V2', 'Panigale V4', 'Panigale V4 S', 'Panigale V4 R', 'Panigale 899', 'Panigale 959',
      // Monster Series
      'Monster 821', 'Monster 1200', 'Monster 1200 S', 'Monster Plus', 'Monster SP',
      // Scrambler Series
      'Scrambler Icon', 'Scrambler Cafe Racer', 'Scrambler Desert Sled', 'Scrambler Full Throttle',
      'Scrambler Sixty2', 'Scrambler 1100',
      // Multistrada Series
      'Multistrada 950', 'Multistrada 1260', 'Multistrada V4', 'Multistrada V2',
      // Diavel Series
      'Diavel 1260', 'XDiavel',
      // Hypermotard Series
      'Hypermotard 950', 'Hypermotard 950 SP'
    ],
    bmw: [
      // GS Series
      'G 310 GS', 'G 310 R', 'F 750 GS', 'F 850 GS', 'R 1250 GS', 'R 1300 GS',
      // R Series
      'R nineT', 'R 18', 'R 1250 R', 'R 1250 RT',
      // S Series
      'S 1000 RR', 'S 1000 R', 'S 1000 XR',
      // F Series
      'F 900 R', 'F 900 XR',
      // K Series
      'K 1600 GT', 'K 1600 GTL'
    ],
    triumph: [
      // Street Triple Series
      'Street Triple', 'Street Triple R', 'Street Triple RS',
      // Bonneville Series
      'Bonneville T100', 'Bonneville T120', 'Bonneville Bobber', 'Bonneville Speedmaster',
      'Bonneville Street Twin', 'Bonneville Street Cup', 'Bonneville Thruxton',
      // Tiger Series
      'Tiger 900', 'Tiger 1200', 'Tiger Sport 660',
      // Rocket Series
      'Rocket 3 R', 'Rocket 3 GT',
      // Speed Series
      'Speed Twin', 'Speed Triple 1200 RS',
      // Scrambler Series
      'Scrambler 1200', 'Scrambler 400X'
    ],
    aprilia: [
      // RS Series
      'RS 660', 'RS 125', 'RS4 125',
      // Tuono Series
      'Tuono V4', 'Tuono 660', 'Tuono 125',
      // Dorsoduro Series
      'Dorsoduro 900',
      // Shiver Series
      'Shiver 900',
      // Scooters
      'SR 160', 'SR 125', 'Vespa SXL', 'Storm 125'
    ],
    piaggio: [
      'Liberty 150', 'Liberty S', 'MP3', 'X10', 'Beverly 300', 'Beverly 400'
    ],
    vespa: [
      'VXL 125', 'VXL 150', 'SXL 125', 'SXL 150', 'ZX 125', 'Elegante 150',
      'Racing Sixties', 'Notte 125', 'Notte 150', 'Urban Club 125', 'RED 125'
    ],
    husqvarna: [
      'Vitpilen 250', 'Vitpilen 401', 'Svartpilen 250', 'Svartpilen 401'
    ],
    moto_guzzi: [
      'V7 Stone', 'V7 Special', 'V85 TT', 'V100 Mandello', 'Audace', 'California'
    ],
    beta: [
      'RR 2T 125', 'RR 4T 125', 'RR 2T 200', 'RR 4T 250', 'RR 4T 300',
      'X-Trainer 300', 'Alp 4.0'
    ],
    gasgas: [
      'EC 250', 'EC 300', 'MC 125', 'MC 250', 'MC 450'
    ],
    // American Brands - Expanded
    harley: [
      // Sportster Series
      'Street 750', 'Street Rod', 'Iron 883', 'Iron 1200', 'Forty Eight', 'Forty Eight Special',
      'Roadster', 'SuperLow', 'Sportster S',
      // Softail Series
      'Fat Boy', 'Fat Bob', 'Breakout', 'Slim', 'Heritage Classic', 'Deluxe', 'Low Rider',
      'Low Rider S', 'Sport Glide', 'Standard',
      // Touring Series
      'Road King', 'Road King Special', 'Street Glide', 'Street Glide Special', 'Road Glide',
      'Road Glide Special', 'Ultra Limited', 'Electra Glide Standard',
      // CVO Series
      'CVO Street Glide', 'CVO Road Glide', 'CVO Limited',
      // Pan America Series
      'Pan America 1250', 'Pan America 1250 Special',
      // Bronx Series
      'Bronx'
    ],
    indian: [
      // Scout Series
      'Scout', 'Scout Sixty', 'Scout Bobber', 'Scout Rogue', 'Scout Bobber Twenty',
      // Chief Series
      'Chief', 'Chief Dark Horse', 'Chief Bobber', 'Super Chief',
      // Challenger Series
      'Challenger', 'Challenger Dark Horse',
      // FTR Series
      'FTR 1200', 'FTR 1200 S', 'FTR 1200 Rally'
    ],
    zero: [
      'SR/F', 'SR/S', 'S', 'DS', 'FX', 'FXS'
    ],
    // Chinese Brands - Expanded
    cfmoto: [
      'NK 150', 'NK 250', 'NK 400', 'NK 650', 'NK 800',
      'SR 150', 'SR 250', 'MT 650', '300NK', '400NK', '650NK', '700CL-X'
    ],
    benelli: [
      'TNT 135', 'TNT 150i', 'TNT 200', 'TNT 249S', 'TNT 300', 'TNT 600i',
      'Leoncino 250', 'Leoncino 500', 'TRK 251', 'TRK 502', 'TRK 502X',
      '302R', '600RR', 'Imperiale 400'
    ],
    keeway: [
      'RKF 125', 'RKS 125', 'Superlight 125', 'Superlight 200', 'K-Light 125',
      'K-Light 202', 'V302C', 'Benda 300'
    ],
    zongshen: [
      'Z-One 125', 'Z-One 150', 'RX1', 'RX1S', 'RX3', 'RX3S', 'TC 250'
    ],
    lifan: [
      'KPR 150', 'KPR 200', 'KPT 150', 'KPT 200', 'X-PECT 200'
    ],
    haojue: [
      'TR 150', 'TR 300', 'DM 150', 'DM 250', 'HJ 125-K'
    ],
    // Korean Brands - Expanded
    hyosung: [
      'GT 125R', 'GT 250R', 'GT 650R', 'GD 250N', 'GV 125', 'GV 250', 'GV 650'
    ],
    daelim: [
      'Roadsport 125', 'Roadsport 250', 'VJF 125', 'VJF 250', 'Roadwin 125', 'Roadwin 250'
    ],
    // Thai Brands
    gpr: [
      'Tornado 250', 'Demon 150', 'Demon 125', 'Gentleman 200', 'Legend 250'
    ],
    // Malaysian Brands
    modenas: [
      'Pulsar NS 200', 'Pulsar RS 200', 'Dominar 400', 'V15', 'CT 100', 'Ace 115'
    ],
    // Vietnamese Brands
    vinfast: [
      'Klara A1', 'Klara A2', 'Klara S', 'Impes', 'Vento', 'Theon', 'Theon S'
    ],
    // Taiwanese Brands - Expanded
    kymco: [
      'People 125', 'People 150', 'People 300', 'Like 125', 'Like 150', 'Like 200i',
      'X-Town 125', 'X-Town 300', 'AK 550', 'CV3', 'Xciting 400i',
      'Super 8 125', 'Super 8 150', 'Agility 125'
    ],
    sym: [
      'Joyride 125', 'Joyride 200', 'Wolf 125', 'Wolf 150', 'Jet 4 125', 'Jet 4 150',
      'Citycom 300', 'GTS 125', 'GTS 250', 'Maxsym 400', 'Maxsym 600'
    ],
    gogoro: [
      'Gogoro 1', 'Gogoro 2', 'Gogoro 3', 'Gogoro VIVA', 'Gogoro S2'
    ],
    // Brazilian Brands
    shineray: [
      'XY 125', 'XY 150', 'XY 200', 'XY 250', 'Phoenix 50', 'Smart 50'
    ],
    // Electric Specialized Brands
    energica: [
      'Ego', 'Ego+', 'Eva', 'Eva Ribelle', 'Experia'
    ],
    lightning: [
      'LS-218', 'Strike'
    ],
    cake: [
      'Kalk OR', 'Kalk&', 'Ösa', 'Makka'
    ],
    // Legacy/Classic Indian Brands
    lml: [
      'Vespa PX 125', 'Vespa PX 150', 'Star 125', 'Star 150', 'Graptor 125', 'Graptor 150'
    ],
    kinetic: [
      'Blaze 165', 'Nova', 'Honda', 'Marvel', 'Legend'
    ],
    // Universal Categories
    generic: [
      'Universal Fit', 'Multi-Brand Compatible', 'Standard Size', 'Common Pattern',
      'ISO Standard', 'OEM Equivalent', 'Aftermarket Compatible'
    ],
    oem: [
      'Original Equipment', 'Factory Specification', 'Genuine Part', 'OE Replacement',
      'Manufacturer Specification'
    ],
    aftermarket: [
      'Performance Upgrade', 'High Performance', 'Racing Spec', 'Custom Fit',
      'Enhanced Version', 'Modified Specification', 'Tuning Part'
    ],


    honda: [
      // Motorcycles
      'CB Hornet 160R', 'CB Hornet 180R', 'CB Hornet 200R', 'CB Unicorn', 'CB Unicorn 150', 'CB Unicorn 160',
      'CB Shine', 'CB Shine SP', 'X-Blade', 'CB350RS', 'CBR 150R', 'CBR 250R', 'CBR 300R', 'CBR 650R', 'CBR 1000RR',
      'Livo', 'Dream Yuga', 'Dream Neo', 'CD 110 Dream', 'CD Dawn',
      // Scooters
      'Activa 3G', 'Activa 4G', 'Activa 5G', 'Activa 6G', 'Activa 125', 'Dio', 'Grazia', 'PCX 150',
      'Aviator', 'Elite 125'
    ],
    kawasaki: [
      'Ninja 300', 'Ninja 400', 'Ninja 650', 'Ninja 1000SX', 'Ninja ZX-10R', 'Ninja ZX-6R',
      'Z250', 'Z400', 'Z650', 'Z900', 'Z1000', 'ZX-25R',
      'Versys 300', 'Versys 650', 'Versys 1000',
      'W175', 'W800', 'Vulcan S', 'Eliminator'
    ],

    yamaha: [
      // Sport Bikes
      'YZF-R15', 'YZF-R15 V3', 'YZF-R15 V4', 'YZF-R25', 'YZF-R3', 'YZF-R6', 'YZF-R1',
      'MT-15', 'MT-25', 'MT-03', 'MT-07', 'MT-09', 'MT-10',
      // Commuter Bikes
      'FZ-S', 'FZ-S V3', 'FZ-X', 'FZ25', 'Fazer 25',
      'Saluto 125', 'Saluto RX', 'Ray ZR', 'Ray ZR 125',
      // Scooters
      'Fascino 125', 'Ray ZR Street Rally', 'Aerox 155',
      // Cruiser
      'FZ-S FI V2', 'SZ-RR V2',
      // Adventure
      'Tenere 700', 'XT1200Z Super Tenere'
    ],

    // Suzuki models (missing in original)
    suzuki: [
      // Sport Bikes
      'GSX-R150', 'GSX-R125', 'GSX-S150', 'GSX-R600', 'GSX-R750', 'GSX-R1000',
      'GSX-S750', 'GSX-S1000',
      // Commuter Bikes
      'Gixxer 155', 'Gixxer SF 155', 'Gixxer 250', 'Gixxer SF 250',
      'Intruder 155', 'Avenis 125',
      // Scooters
      'Access 125', 'Burgman Street 125', 'Burgman 400',
      // Adventure
      'V-Strom 650', 'V-Strom 1000', 'V-Strom 1050',
      // Cruiser
      'Boulevard M109R', 'Boulevard C50'
    ],

    // Honda models (comprehensive list)
    honda: [
      // Motorcycles
      'CB Hornet 160R', 'CB Hornet 180R', 'CB Hornet 200R', 'CB Unicorn', 'CB Unicorn 150', 'CB Unicorn 160',
      'CB Shine', 'CB Shine SP', 'X-Blade', 'CB350RS', 'CBR 150R', 'CBR 250R', 'CBR 300R', 'CBR 650R', 'CBR 1000RR',
      'Livo', 'Dream Yuga', 'Dream Neo', 'CD 110 Dream', 'CD Dawn', 'SP 125', 'CB125F',
      'Africa Twin', 'Gold Wing', 'Rebel 300', 'Rebel 500',
      // Scooters
      'Activa 3G', 'Activa 4G', 'Activa 5G', 'Activa 6G', 'Activa 125', 'Dio', 'Grazia', 'PCX 150',
      'Aviator', 'Elite 125', 'Forza 300'
    ],

    // Kawasaki models
    kawasaki: [
      'Ninja 300', 'Ninja 400', 'Ninja 650', 'Ninja 1000SX', 'Ninja ZX-10R', 'Ninja ZX-6R', 'Ninja ZX-25R',
      'Z250', 'Z400', 'Z650', 'Z900', 'Z1000', 'ZH2',
      'Versys 300', 'Versys 650', 'Versys 1000',
      'W175', 'W800', 'Vulcan S', 'Eliminator',
      'KLX 140', 'KLX 230', 'KX 250'
    ],

    // Ola Electric models
    ola: [
      'S1', 'S1 Pro', 'S1 Air', 'S1 Pro Gen 2', 'S1 X'
    ],

    // Ather Energy models
    ather: [
      'Ather 450X', 'Ather 450 Plus', 'Ather 450', 'Ather 340'
    ],

    // Revolt Motors models
    revolt: [
      'RV 400', 'RV 300', 'RV1', 'RV1+', 'RV1 Pro'
    ],

    // Mahindra Two Wheelers models
    mahindra: [
      'Gusto 110', 'Gusto 125', 'Rodeo RZ', 'Rodeo UZO', 'Flyte', 'Duro DZ', 'Centuro', 'Pantero',
      'Stallio', 'Kine', 'Rodeo', 'Duro'
    ],

    // VinFast models
    vinfast: [
      'Klara A1', 'Klara A2', 'Klara S', 'Impes', 'Vento', 'Theon', 'Theon S',
      'Feliz S', 'Tempest'
    ]
  };

  const allBikeModels = { ...bikeModels };

  const generateBarcode = () => {
    // Generate 12 digits for EAN-13 (13th is check digit)
    const countryCode = '890'; // India country code
    const companyCode = '12345'; // Your company code (5 digits)
    const productCode = Math.floor(Math.random() * 10000).toString().padStart(4, '0'); // 4 digits

    const first12Digits = countryCode + companyCode + productCode;

    // Calculate EAN-13 check digit
    let sum = 0;
    for (let i = 0; i < 12; i++) {
      const digit = parseInt(first12Digits[i]);
      sum += i % 2 === 0 ? digit : digit * 3;
    }
    const checkDigit = (10 - (sum % 10)) % 10;

    return first12Digits + checkDigit;
  };

  // Standard Barcode Display Component
  const StandardBarcodeDisplay = ({ barcode, size = 'lg' }) => {
    if (!barcode || barcode.length !== 13) {
      return <span className="text-sm text-gray-400">Invalid barcode</span>;
    }

    const width = size === 'lg' ? 300 : 200;
    const height = size === 'lg' ? 80 : 50;
    const fontSize = size === 'lg' ? 12 : 8;

    // EAN-13 bar patterns
    const leftOddPattern = {
      '0': '0001101', '1': '0011001', '2': '0010011', '3': '0111101',
      '4': '0100011', '5': '0110001', '6': '0101111', '7': '0111011',
      '8': '0110111', '9': '0001011'
    };

    const leftEvenPattern = {
      '0': '0100111', '1': '0110011', '2': '0011011', '3': '0100001',
      '4': '0011101', '5': '0111001', '6': '0000101', '7': '0010001',
      '8': '0001001', '9': '0010111'
    };

    const rightPattern = {
      '0': '1110010', '1': '1100110', '2': '1101100', '3': '1000010',
      '4': '1011100', '5': '1001110', '6': '1010000', '7': '1000100',
      '8': '1001000', '9': '1110100'
    };

    // First digit pattern determines left side pattern
    const firstDigitPatterns = {
      '0': 'OOOOOO', '1': 'OOEOEE', '2': 'OOEEOE', '3': 'OOEEEO',
      '4': 'OEOOEE', '5': 'OEEOOE', '6': 'OEEEOO', '7': 'OEOEOE',
      '8': 'OEOEEO', '9': 'OEEOEO'
    };

    const firstDigit = barcode[0];
    const leftDigits = barcode.substring(1, 7);
    const rightDigits = barcode.substring(7, 13);
    const pattern = firstDigitPatterns[firstDigit];

    let binaryString = '101'; // Start pattern

    // Left side
    for (let i = 0; i < 6; i++) {
      const digit = leftDigits[i];
      if (pattern[i] === 'O') {
        binaryString += leftOddPattern[digit];
      } else {
        binaryString += leftEvenPattern[digit];
      }
    }

    binaryString += '01010'; // Center pattern

    // Right side
    for (let i = 0; i < 6; i++) {
      const digit = rightDigits[i];
      binaryString += rightPattern[digit];
    }

    binaryString += '101'; // End pattern

    // Create SVG bars
    const bars = [];
    let x = 10;
    const barWidth = (width - 20) / binaryString.length;

    for (let i = 0; i < binaryString.length; i++) {
      if (binaryString[i] === '1') {
        bars.push(
          <rect
            key={i}
            x={x}
            y={10}
            width={barWidth}
            height={height - 30}
            fill="#000"
          />
        );
      }
      x += barWidth;
    }

    return (
      <div className="flex flex-col items-center space-y-2">
        <div className="bg-white p-4 border border-gray-200 rounded-lg shadow-sm">
          <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
            {bars}
            {/* Display numbers below barcode */}
            <text x="15" y={height - 5} fontSize={fontSize - 2} fill="#000" fontFamily="monospace">
              {firstDigit}
            </text>
            <text x={width * 0.25} y={height - 5} fontSize={fontSize - 2} fill="#000" fontFamily="monospace" textAnchor="middle">
              {leftDigits}
            </text>
            <text x={width * 0.75} y={height - 5} fontSize={fontSize - 2} fill="#000" fontFamily="monospace" textAnchor="middle">
              {rightDigits}
            </text>
          </svg>
        </div>
        <div className="text-center">
          <p className="text-xs text-gray-500 font-mono">{barcode}</p>
          <p className="text-xs text-gray-400">EAN-13 Barcode</p>
        </div>
      </div>
    );
  }
  // Initialize form data
  // Initialize form data
 // FIXED: Initialize form data and barcode properly
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: '',
        partNumber: '',
        description: '',
        sku: '',
        price: '',
        sellingPrice: '',
        comparePrice: '',
        stock: '',
        reorderLevel: '',
        lowStockThreshold: '10',
        categories: [],
        brands: [],
        modelCompatibility: [],
        weight: '',
        dimensions: { length: '', width: '', height: '' },
        location: '',
        barcode: '',
        hsnCode: '',
        warrantyMonths: '',
        notes: '',
        images: [],
        specifications: [],
        isActive: true,
        ...initialData
      });

      if (initialData.specifications) {
        setSpecifications(initialData.specifications);
      }
      if (initialData.modelCompatibility) {
        setModelCompatibility(initialData.modelCompatibility);
      }
      if (initialData.imageUrls && initialData.imageUrls.length > 0) {
        setImagePreviewUrls([...initialData.imageUrls]);
      }
      if (initialData.name) {
        setProductNameSearch(initialData.name);
      }

      // FIXED: Handle barcode based on edit mode
      if (isEdit && initialData.barcode) {
        // Edit mode: Use existing barcode from database
        console.log('Edit mode: Using existing barcode:', initialData.barcode);
        setGeneratedBarcode(initialData.barcode);
        setFormData(prev => ({ ...prev, barcode: initialData.barcode }));
      } else if (!isEdit || !initialData.barcode) {
        // Create mode or edit mode without barcode: Generate new barcode
        const newBarcode = generateBarcode();
        console.log('Create mode: Generated new barcode:', newBarcode);
        setGeneratedBarcode(newBarcode);
        setFormData(prev => ({ ...prev, barcode: newBarcode }));
      }

    } else if (!isEdit) {
      // Generate barcode only for new products when no initialData
      const newBarcode = generateBarcode();
      console.log('New product: Generated barcode:', newBarcode);
      setGeneratedBarcode(newBarcode);
      setFormData(prev => ({ ...prev, barcode: newBarcode }));
    }
  }, [initialData, isEdit]);


  // Auto-generate barcode on component mount
 useEffect(() => {
    if (!isEdit && !generatedBarcode && !initialData?.barcode) {
      const newBarcode = generateBarcode();
      console.log('Auto-generating barcode for new product:', newBarcode);
      setGeneratedBarcode(newBarcode);
      setFormData(prev => ({ ...prev, barcode: newBarcode }));
    }
  }, [isEdit, generatedBarcode, initialData?.barcode]);

  // Fetch models when selected brands change
  useEffect(() => {
    if (formData.brands && formData.brands.length > 0) {
      const modelsForSelectedBrands = [];

      formData.brands.forEach(brandId => {
        const brand = brands.find(b => b.id === brandId);
        if (brand) {
          const brandNameLower = brand.name.toLowerCase();
          let brandKey = brandNameMapping[brandNameLower];

          if (!brandKey) {
            brandKey = brandNameLower.replace(/\s+/g, '_').replace(/[^a-z0-9_]/g, '');
          }

          const brandModels = allBikeModels[brandKey] || [];
          brandModels.forEach(modelName => {
            modelsForSelectedBrands.push({
              name: modelName,
              brandName: brand.name,
              brandId: brandId
            });
          });
        }
      });

      setComputedAvailableModels(modelsForSelectedBrands);
    } else {
      setComputedAvailableModels([]);
    }
  }, [formData.brands, brands]);

  // Update product suggestions when search changes
  useEffect(() => {
    if (productNameSearch.length > 0) {
      const filtered = commonBikePartNames.filter(name =>
        name.toLowerCase().includes(productNameSearch.toLowerCase())
      );
      setProductSuggestions(filtered);
    } else {
      setProductSuggestions([]);
    }
  }, [productNameSearch]);

  // Update model suggestions
  useEffect(() => {
    if (activeModelIndex !== null && computedAvailableModels.length > 0) {
      if (modelSearch.length > 0) {
        const filtered = computedAvailableModels.filter(model =>
          model.name.toLowerCase().includes(modelSearch.toLowerCase())
        );
        setModelSuggestions(filtered);
        setShowModelSuggestions(true);
      } else {
        setModelSuggestions(computedAvailableModels);
        setShowModelSuggestions(computedAvailableModels.length > 0);
      }
    } else {
      setModelSuggestions([]);
      setShowModelSuggestions(false);
    }
  }, [modelSearch, activeModelIndex, computedAvailableModels]);

  // Clear model compatibility when brands change
  useEffect(() => {
    if (formData.brands && formData.brands.length > 0 && !isEdit) {
      setModelCompatibility([]);
    }
  }, [formData.brands, isEdit]);

  // Handle clicks outside of dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (productSearchRef.current && !productSearchRef.current.contains(event.target)) {
        setShowProductSuggestions(false);
      }
      if (modelSearchRef.current && !modelSearchRef.current.contains(event.target)) {
        setShowModelSuggestions(false);
        setActiveModelIndex(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  // Filter categories based on search
  useEffect(() => {
    if (categorySearch.trim() === '') {
      setFilteredCategories(categories);
    } else {
      const filtered = categories.filter(category =>
        category.name.toLowerCase().includes(categorySearch.toLowerCase()) ||
        (category.description && category.description.toLowerCase().includes(categorySearch.toLowerCase()))
      );
      setFilteredCategories(filtered);
    }
  }, [categories, categorySearch]);

  // Initialize filtered categories when categories change
  useEffect(() => {
    setFilteredCategories(categories);
  }, [categories]);


  // Filter brands based on search
useEffect(() => {
  if (brandSearch.trim() === '') {
    setFilteredBrands(brands);
  } else {
    const filtered = brands.filter(brand =>
      brand.name.toLowerCase().includes(brandSearch.toLowerCase()) ||
      (brand.description && brand.description.toLowerCase().includes(brandSearch.toLowerCase()))
    );
    setFilteredBrands(filtered);
  }
}, [brands, brandSearch]);

// Initialize filtered brands when brands change
useEffect(() => {
  setFilteredBrands(brands);
}, [brands]);


  // Handle form field change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === 'checkbox') {
      setFormData({
        ...formData,
        [name]: checked
      });
    } else if (name.startsWith('dimensions.')) {
      const dimensionKey = name.split('.')[1];
      setFormData({
        ...formData,
        dimensions: {
          ...formData.dimensions,
          [dimensionKey]: value
        }
      });
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }

    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: ''
      });
    }
  };

  // Handle barcode change
  // Handle barcode change
  // Handle barcode change
  const handleBarcodeChange = (e) => {
    const value = e.target.value;
    setGeneratedBarcode(value);
    setFormData(prev => ({ ...prev, barcode: value }));
  };

  // Regenerate barcode
  const handleRegenerateBarcode = () => {
    const newBarcode = generateBarcode();
    setGeneratedBarcode(newBarcode);
    setFormData(prev => ({ ...prev, barcode: newBarcode }));
  };

  // Handle product name search change
  const handleProductNameChange = (e) => {
    const value = e.target.value;
    setProductNameSearch(value);
    setFormData({
      ...formData,
      name: value
    });
    setShowProductSuggestions(value.length > 0);

    if (errors.name) {
      setErrors({
        ...errors,
        name: ''
      });
    }
  };

  // Handle product suggestion selection
  const handleProductSuggestionSelect = (suggestion) => {
    setProductNameSearch(suggestion);
    setFormData({
      ...formData,
      name: suggestion
    });
    setShowProductSuggestions(false);
  };

  // Handle category selection
  const handleCategoryChange = (category, checked) => {
    let updatedCategories;

    if (checked) {
      updatedCategories = [...(formData.categories || []), category];
    } else {
      updatedCategories = (formData.categories || []).filter(cat =>
        (cat.id && cat.id !== category.id) || (typeof cat === 'string' && cat !== category.id)
      );
    }

    setFormData({
      ...formData,
      categories: updatedCategories
    });

    if (errors.categories) {
      setErrors({
        ...errors,
        categories: ''
      });
    }
  };

  // Handle brand selection
  const handleBrandChange = (brandId, checked) => {
    let updatedBrands;

    if (checked) {
      updatedBrands = [...(formData.brands || []), brandId];
    } else {
      updatedBrands = (formData.brands || []).filter(id => id !== brandId);
    }

    setFormData({
      ...formData,
      brands: updatedBrands
    });

    if (!isEdit) {
      setModelCompatibility([]);
    }

    if (errors.brands) {
      setErrors({
        ...errors,
        brands: ''
      });
    }
  };

  // Handle model compatibility
  const handleAddModel = () => {
    if (!formData.brands || formData.brands.length === 0) {
      alert('Please select at least one bike brand first to add compatible models.');
      return;
    }
    setModelCompatibility([...modelCompatibility, '']);
  };

  const handleRemoveModel = (index) => {
    const newModels = [...modelCompatibility];
    newModels.splice(index, 1);
    setModelCompatibility(newModels);
  };

  const handleModelChange = (index, value) => {
    const newModels = [...modelCompatibility];
    newModels[index] = value;
    setModelCompatibility(newModels);
    setModelSearch(value);
    setActiveModelIndex(index);

    if (value.length === 0 && availableModels.length > 0) {
      setModelSuggestions(availableModels);
      setShowModelSuggestions(true);
    }
  };

  const handleModelSuggestionSelect = (suggestion, index) => {
    const newModels = [...modelCompatibility];
    newModels[index] = suggestion.name;
    setModelCompatibility(newModels);
    setModelSearch('');
    setShowModelSuggestions(false);
    setActiveModelIndex(null);
  };

  // Handle image upload
  const handleImageUpload = (files) => {
    if (!files || files.length === 0) return;

    const filesArray = Array.from(files);
    const validFiles = filesArray.filter(file => {
      if (!file.type.startsWith('image/')) return false;
      if (file.size > 10 * 1024 * 1024) return false;
      return true;
    });

    if (validFiles.length === 0) return;

    setImageFiles(prevFiles => [...prevFiles, ...validFiles]);

    validFiles.forEach(file => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviewUrls(prevPreviews => [...prevPreviews, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  // Handle image removal
  const handleImageRemove = (index) => {
    const existingImagesCount = isEdit ? (initialData?.imageUrls?.length || 0) : 0;

    if (isEdit && index < existingImagesCount) {
      setRemovedImageIndexes(prev => [...prev, index]);
    }

    setImagePreviewUrls(prev => prev.filter((_, i) => i !== index));

    if (index >= existingImagesCount) {
      const newFileIndex = index - existingImagesCount;
      setImageFiles(prev => prev.filter((_, i) => i !== newFileIndex));
    }
  };

  // Handle specification functions
  const handleAddSpecification = () => {
    setSpecifications([...specifications, { name: '', value: '' }]);
  };

  const handleRemoveSpecification = (index) => {
    const newSpecifications = [...specifications];
    newSpecifications.splice(index, 1);
    setSpecifications(newSpecifications);
  };

  const handleSpecificationChange = (index, field, value) => {
    const newSpecifications = [...specifications];
    newSpecifications[index][field] = value;
    setSpecifications(newSpecifications);
  };

  // Handle add category
  const handleAddCategory = async () => {
    try {
      if (!newCategory.name.trim()) {
        alert('Please enter a category name');
        return;
      }

      const categoryData = {
        name: newCategory.name,
        description: newCategory.description,
        image: newCategory.image
      };

      if (onAddCategory) {
        await onAddCategory(categoryData);
        setNewCategory({ name: '', description: '', image: null });
        setShowAddCategoryModal(false);
      }
    } catch (error) {
      console.error('Error adding category:', error);
      alert('Failed to add category');
    }
  };

  // Handle add brand
  const handleAddBrand = async () => {
    try {
      if (!newBrand.name.trim()) {
        alert('Please enter a brand name');
        return;
      }

      const brandData = {
        name: newBrand.name,
        description: newBrand.description,
        logo: newBrand.logo,
        website: newBrand.website
      };

      if (onAddBrand) {
        await onAddBrand(brandData);
        setNewBrand({ name: '', description: '', logo: null, website: '' });
        setShowAddBrandModal(false);
      }
    } catch (error) {
      console.error('Error adding brand:', error);
      alert('Failed to add brand');
    }
  };

  // Validate form
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name?.trim()) {
      newErrors.name = 'Part name is required';
    }

    if (!formData.partNumber?.trim()) {
      newErrors.partNumber = 'Part number is required';
    }

    if (!(isMainAdmin && enableAdminMode) && !formData.barcode?.trim()) {
  newErrors.barcode = 'Barcode is required';
}

    if (!formData.price) {
      newErrors.price = 'Selling price is required';
    } else if (isNaN(Number(formData.price)) || Number(formData.price) < 0) {
      newErrors.price = 'Selling price must be a positive number';
    }

    if (!formData.stock) {
      newErrors.stock = 'Stock quantity is required';
    } else if (isNaN(Number(formData.stock)) || Number(formData.stock) < 0) {
      newErrors.stock = 'Stock quantity must be a positive number';
    }

    if (!formData.reorderLevel) {
      newErrors.reorderLevel = 'Reorder level is required';
    } else if (isNaN(Number(formData.reorderLevel)) || Number(formData.reorderLevel) < 0) {
      newErrors.reorderLevel = 'Reorder level must be a positive number';
    }

    if (formData.hsnCode && !/^\d{4,8}$/.test(formData.hsnCode)) {
      newErrors.hsnCode = 'HSN Code must be 4-8 digits';
    }

    if (formData.warrantyMonths && (isNaN(Number(formData.warrantyMonths)) || Number(formData.warrantyMonths) < 0)) {
      newErrors.warrantyMonths = 'Warranty must be a positive number';
    }

    if (formData.dimensions) {
      const dimensions = formData.dimensions;
      if (dimensions.length && isNaN(Number(dimensions.length))) {
        newErrors['dimensions.length'] = 'Length must be a number';
      }
      if (dimensions.width && isNaN(Number(dimensions.width))) {
        newErrors['dimensions.width'] = 'Width must be a number';
      }
      if (dimensions.height && isNaN(Number(dimensions.height))) {
        newErrors['dimensions.height'] = 'Height must be a number';
      }
    }

    if (formData.weight && isNaN(Number(formData.weight))) {
      newErrors.weight = 'Weight must be a number';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 // Vehicle Search Function - Main Admin Only
const handleVehicleSearch = async (searchTerm) => {
  if (!searchTerm || searchTerm.length < 2) {
    setVehicleSearchResults([]);
    setShowVehicleResults(false);
    return;
  }

  setIsSearchingVehicle(true);
  try {
    const productsRef = collection(db, 'products');
    const snapshot = await getDocs(productsRef);
    
    const results = [];
    const searchLower = searchTerm.toLowerCase();
    
    snapshot.forEach((doc) => {
      const product = { id: doc.id, ...doc.data() };
      const vehicleNum = (product.vehicleNumber || '').toLowerCase();
      const compatibleModels = Array.isArray(product.modelCompatibility) 
        ? product.modelCompatibility.join(' ').toLowerCase() 
        : '';
      const productName = (product.name || '').toLowerCase();
      
      if (vehicleNum.includes(searchLower) || 
          compatibleModels.includes(searchLower) || 
          productName.includes(searchLower)) {
        results.push(product);
      }
    });

    setVehicleSearchResults(results.slice(0, 10));
    setShowVehicleResults(true);
  } catch (error) {
    console.error('Error searching:', error);
  } finally {
    setIsSearchingVehicle(false);
  }
};

// Debounced vehicle search
useEffect(() => {
  if (!isMainAdmin || !enableAdminMode) return;
  
  const timer = setTimeout(() => {
    if (vehicleSearch) {
      handleVehicleSearch(vehicleSearch);
    }
  }, 300);

  return () => clearTimeout(timer);
}, [vehicleSearch, isMainAdmin, enableAdminMode]);

  // Handle form submission
  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // Ensure we always have a valid barcode before submitting
    let finalBarcode = generatedBarcode;
    if (!finalBarcode || finalBarcode.trim() === '') {
      finalBarcode = generateBarcode();
      setGeneratedBarcode(finalBarcode);
    }

    const parsedData = {
      ...formData,
      price: Number(formData.price),
      sellingPrice: Number(formData.price),
      stock: Number(formData.stock),
      reorderLevel: Number(formData.reorderLevel),
      lowStockThreshold: Number(formData.reorderLevel),
      barcode: finalBarcode // Always use the generated/valid barcode
    };

    if (formData.comparePrice) {
      parsedData.comparePrice = Number(formData.comparePrice);
    }

    if (formData.weight) {
      parsedData.weight = Number(formData.weight);
    }

    if (formData.warrantyMonths) {
      parsedData.warrantyMonths = Number(formData.warrantyMonths);
    }

    if (formData.dimensions) {
      parsedData.dimensions = {
        length: formData.dimensions.length ? Number(formData.dimensions.length) : null,
        width: formData.dimensions.width ? Number(formData.dimensions.width) : null,
        height: formData.dimensions.height ? Number(formData.dimensions.height) : null
      };
    }

    parsedData.specifications = specifications.filter(spec => spec.name.trim() && spec.value.trim());
    parsedData.modelCompatibility = modelCompatibility.filter(model => model.trim());

    if (imageFiles.length > 0) {
      parsedData.images = imageFiles;
    }

    if (isEdit && removedImageIndexes.length > 0) {
      parsedData.removedImageIndexes = removedImageIndexes;
    }


 // Main Admin products are ALWAYS private - regardless of toggle
if (isMainAdmin) {
  parsedData.mainAdminOnly = true;
  parsedData.createdByMainAdmin = true;
  parsedData.barcode = generatedBarcode;
  
  // Only add vehicleNumber if admin mode toggle is ON and value exists
  if (enableAdminMode && vehicleNumber) {
    parsedData.vehicleNumber = vehicleNumber;
  }
}



    onSubmit(parsedData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-8">


     

    {/* Basic Information Section */}
<div className="bg-white p-6 rounded-lg border border-gray-200">
  <div className="flex justify-between items-center mb-4">
    <h3 className="text-lg font-medium text-gray-900">Basic Information</h3>
    
    {/* Main Admin Toggle */}
    {isMainAdmin && (
      <div className="flex items-center space-x-3">
        <span className="text-sm text-gray-600">Admin Mode</span>
        <button
          type="button"
          onClick={() => setEnableAdminMode(!enableAdminMode)}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
            enableAdminMode ? 'bg-purple-600' : 'bg-gray-300'
          }`}
        >
          <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            enableAdminMode ? 'translate-x-6' : 'translate-x-1'
          }`} />
        </button>
      </div>
    )}
  </div>



 
 {/* Vehicle Number Plate Search - Only when Admin Mode is ON */}
{isMainAdmin && enableAdminMode && (
  <div className="mb-6">
    <label className="block text-sm font-medium text-gray-700 mb-2">
      🚗 Vehicle Number Plate
    </label>
    <div className="relative">
      <input
        type="text"
        placeholder="Enter vehicle number (e.g., KA01AB1234)"
        value={vehicleNumber}
        onChange={(e) => setVehicleNumber(e.target.value.toUpperCase())}
        className="block w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent uppercase tracking-wider font-mono"
      />
      {vehicleNumber && (
        <button
          type="button"
          onClick={() => setVehicleNumber('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
    <p className="mt-1 text-xs text-gray-500">
      Enter vehicle number to fetch details (API integration coming soon)
    </p>
  </div>
)}



        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          {/* Enhanced Product Name with Search */}
          <div className="relative" ref={productSearchRef}>
            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
              Part Name
            </label>
            <div className="mt-1 relative">
              <input
                type="text"
                id="name"
                name="name"
                value={productNameSearch}
                onChange={handleProductNameChange}
                onFocus={() => setShowProductSuggestions(productNameSearch.length > 0)}
                className={`block w-full px-3 py-2 border ${errors.name ? 'border-red-300' : 'border-gray-300'
                  } rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm`}
                placeholder="Start typing to search auto parts..."
                autoComplete="off"
              />
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                </svg>
              </div>
            </div>

            {/* Product Suggestions Dropdown */}
            {showProductSuggestions && productSuggestions.length > 0 && (
              <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                {productSuggestions.map((suggestion, index) => (
                  <div
                    key={index}
                    className="cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-orange-50 hover:text-orange-900"
                    onClick={() => handleProductSuggestionSelect(suggestion)}
                  >
                    <span className="font-normal block truncate">{suggestion}</span>
                  </div>
                ))}
              </div>
            )}

            {errors.name && (
              <p className="mt-2 text-sm text-red-600">{errors.name}</p>
            )}
          </div>


          <Input
      label="HSN Code"
      id="hsnCode"
      name="hsnCode"
      type="text"
      value={formData.hsnCode || ''}
      onChange={handleChange}
      error={errors.hsnCode}
      placeholder="GST classification code (4-8 digits)"
    />
  </div>

  {/* Barcode Section - HIDE when Admin Mode is ON */}
  {!(isMainAdmin && enableAdminMode) && (
    <div className="mt-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        Barcode (Auto-Generated)
      </label>
      <div className="flex items-center space-x-4">
        <div className="flex-1">
          <input
            type="text"
            value={generatedBarcode}
            onChange={handleBarcodeChange}
            className={`block w-full px-3 py-2 border ${errors.barcode ? 'border-red-300' : 'border-gray-300'
              } rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm font-mono`}
            placeholder="Barcode will be auto-generated"
          />
          {errors.barcode && (
            <p className="mt-1 text-sm text-red-600">{errors.barcode}</p>
          )}
        </div>
        <Button
          type="button"
          variant="secondary"
          onClick={handleRegenerateBarcode}
          className="whitespace-nowrap"
        >
          <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          Regenerate
        </Button>
      </div>
      <p className="mt-1 text-xs text-gray-500">
        Barcode is automatically generated. You can manually edit it or regenerate a new one.
      </p>
    </div>
  )}

        <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
          <Input
            label="Part Number"
            id="partNumber"
            name="partNumber"
            type="text"
            value={formData.partNumber || ''}
            onChange={handleChange}
            error={errors.partNumber}
            placeholder="Unique part identifier/SKU"
          />

          <Input
            label="Warranty (Months)"
            id="warrantyMonths"
            name="warrantyMonths"
            type="number"
            min="0"
            value={formData.warrantyMonths || ''}
            onChange={handleChange}
            error={errors.warrantyMonths}
            placeholder="Number of months"
          />
        </div>

        <div className="mt-6">
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <div className="mt-1">
            <textarea
              id="description"
              name="description"
              rows={4}
              className="shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full sm:text-sm border border-gray-300 rounded-md"
              value={formData.description || ''}
              onChange={handleChange}
              placeholder="Detailed description of the part..."
            />
          </div>
        </div>
      </div>

      {/* Categories Section with Add Option */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-gray-900">Product Categories</h3>
          <Button
            type="button"
            variant="secondary"
            onClick={() => setShowAddCategoryModal(true)}
            className="text-sm"
          >
            <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Add Category
          </Button>
        </div>
        <p className="text-sm text-gray-500 mb-4">
          Select the categories that best describe this automotive spare part.
        </p>

        {/* Search Bar */}
        <div className="mb-6">
          <div className="relative">
            <input
              type="text"
              placeholder="Search categories..."
              value={categorySearch}
              onChange={(e) => setCategorySearch(e.target.value)}
              className="block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
              </svg>
            </div>
            {categorySearch && (
              <button
                type="button"
                onClick={() => setCategorySearch('')}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            )}
          </div>
          {categorySearch && (
            <p className="mt-2 text-sm text-gray-500">
              Showing {filteredCategories.length} of {categories.length} categories
            </p>
          )}
        </div>

        {filteredCategories.length > 0 ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {filteredCategories.map((category) => {
              const isSelected = formData.categories.some(cat =>
                (cat.id && cat.id === category.id) ||
                (typeof cat === 'string' && cat === category.id) ||
                cat === category
              );
              const categoryImage = category.image || `https://via.placeholder.com/150x120/f0f0f0/666666?text=${category.name.replace(/\s+/g, '+')}`;

              return (
                <div
                  key={category.id}
                  className={`relative overflow-hidden rounded-lg border-2 cursor-pointer transition-all duration-200 bg-white ${isSelected
                    ? 'border-orange-500 shadow-lg'
                    : 'border-gray-200 hover:border-orange-300 hover:shadow-md'
                    }`}
                  onClick={() => handleCategoryChange(category, !isSelected)}
                >
                  <div className="absolute top-2 right-2 z-10">
                    <div className={`w-4 h-4 rounded border-2 flex items-center justify-center ${isSelected
                      ? 'bg-orange-500 border-orange-500'
                      : 'bg-white border-gray-300'
                      }`}>
                      {isSelected && (
                        <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>
                  </div>

                  <div className="h-20 w-full bg-gray-100">
                    <img
                      src={categoryImage}
                      alt={category.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.target.src = `https://via.placeholder.com/150x120/f0f0f0/666666?text=${category.name.replace(/\s+/g, '+')}`;
                      }}
                    />
                  </div>

                  <div className="p-2 text-center">
                    <h4 className="font-medium text-gray-900 text-xs leading-tight">
                      {category.name}
                    </h4>
                  </div>

                  {isSelected && (
                    <div className="absolute inset-0 bg-orange-500 bg-opacity-10 pointer-events-none">
                      <div className="absolute bottom-0 left-0 right-0 h-1 bg-orange-500"></div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ) : categories.length > 0 ? (
          <div className="text-center py-8 text-gray-500">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <p className="mt-2">No categories found matching "{categorySearch}"</p>
            <button
              type="button"
              onClick={() => setCategorySearch('')}
              className="mt-2 text-sm text-orange-600 hover:text-orange-800 font-medium"
            >
              Clear search
            </button>
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">
            <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
            <p className="mt-2">No categories available</p>
            <Button
              type="button"
              variant="secondary"
              onClick={() => setShowAddCategoryModal(true)}
              className="mt-2"
            >
              Add First Category
            </Button>
          </div>
        )}

        {formData.categories.length > 0 && (
          <div className="mt-4 p-3 bg-orange-50 rounded-lg">
            <p className="text-sm font-medium text-orange-800 mb-2">
              Selected Categories ({formData.categories.length}):
            </p>
            <div className="flex flex-wrap gap-2">
              {formData.categories.map((category, index) => (
                <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                  {category.name || category}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Brands Section with Add Option */}
{/* Brands Section with Add Option */}
<div className="bg-white p-6 rounded-lg border border-gray-200">
  <div className="flex justify-between items-center mb-4">
    <h3 className="text-lg font-medium text-gray-900">Brand Information</h3>
    <Button
      type="button"
      variant="secondary"
      onClick={() => setShowAddBrandModal(true)}
      className="text-sm"
    >
      <svg className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
      </svg>
      Add Brand
    </Button>
  </div>
  <p className="text-sm text-gray-500 mb-6">
    Select the brands/manufacturers this automotive spare part is compatible with. You can select multiple brands.
  </p>

  {/* Search Bar */}
  <div className="mb-6">
    <div className="relative">
      <input
        type="text"
        placeholder="Search brands..."
        value={brandSearch}
        onChange={(e) => setBrandSearch(e.target.value)}
        className="block w-full px-3 py-2 pl-10 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
      />
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
        </svg>
      </div>
      {brandSearch && (
        <button
          type="button"
          onClick={() => setBrandSearch('')}
          className="absolute inset-y-0 right-0 pr-3 flex items-center"
        >
          <svg className="h-5 w-5 text-gray-400 hover:text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      )}
    </div>
    {brandSearch && (
      <p className="mt-2 text-sm text-gray-500">
        Showing {filteredBrands.length} of {brands.length} brands
      </p>
    )}
  </div>

  {filteredBrands.length > 0 ? (
    <div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 mb-4">
        {filteredBrands.map((brand) => {
          const isSelected = formData.brands && formData.brands.includes(brand.id);
          const brandLogo = brand.logo || `https://via.placeholder.com/120x60/f0f0f0/666666?text=${brand.name.replace(/\s+/g, '+')}`;

          return (
            <div
              key={brand.id}
              className={`relative overflow-hidden rounded-lg border-2 cursor-pointer transition-all duration-200 bg-white ${isSelected
                ? 'border-orange-500 shadow-lg'
                : 'border-gray-200 hover:border-orange-300 hover:shadow-md'
                }`}
              onClick={() => handleBrandChange(brand.id, !isSelected)}
            >
              <div className="absolute top-2 right-2 z-10">
                <div className={`w-4 h-4 rounded border-2 flex items-center justify-center ${isSelected
                  ? 'bg-orange-500 border-orange-500'
                  : 'bg-white border-gray-300'
                  }`}>
                  {isSelected && (
                    <svg className="w-2.5 h-2.5 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  )}
                </div>
              </div>

              <div className="h-12 w-full bg-gray-50 flex items-center justify-center p-1">
                <img
                  src={brandLogo}
                  alt={brand.name}
                  className="h-full w-auto max-w-full object-contain"
                  onError={(e) => {
                    e.target.src = `https://via.placeholder.com/120x60/f0f0f0/666666?text=${brand.name.replace(/\s+/g, '+')}`;
                  }}
                />
              </div>

              <div className="p-2 text-center">
                <h4 className="font-medium text-gray-900 text-xs leading-tight truncate">
                  {brand.name}
                </h4>
              </div>

              {isSelected && (
                <div className="absolute inset-0 bg-orange-500 bg-opacity-10 pointer-events-none">
                  <div className="absolute bottom-0 left-0 right-0 h-1 bg-orange-500"></div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {formData.brands && formData.brands.length > 0 && (
        <div className="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
          <div className="flex items-center space-x-2">
            <span className="text-sm font-medium text-orange-800">
              Selected Brands ({formData.brands.length}):
            </span>
            <div className="flex flex-wrap gap-2">
              {formData.brands.map((brandId, index) => {
                const brand = brands.find(b => b.id === brandId);
                return (
                  <span key={index} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                    {brand?.name || brandId}
                  </span>
                );
              })}
            </div>
          </div>
          <button
            type="button"
            onClick={() => setFormData({ ...formData, brands: [] })}
            className="text-sm text-orange-600 hover:text-orange-800 font-medium"
          >
            Clear All
          </button>
        </div>
      )}
    </div>
  ) : brands.length > 0 ? (
    <div className="text-center py-8 text-gray-500">
      <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
      <p className="mt-2">No brands found matching "{brandSearch}"</p>
      <button
        type="button"
        onClick={() => setBrandSearch('')}
        className="mt-2 text-sm text-orange-600 hover:text-orange-800 font-medium"
      >
        Clear search
      </button>
    </div>
  ) : (
    <div className="text-center py-8 text-gray-500">
      <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
      <p className="mt-2">No brands available</p>
      <Button
        type="button"
        variant="secondary"
        onClick={() => setShowAddBrandModal(true)}
        className="mt-2"
      >
        Add First Brand
      </Button>
    </div>
  )}

  {errors.brands && (
    <div className="mt-2 p-2 text-sm text-red-600 bg-red-50 rounded">
      {errors.brands}
    </div>
  )}
</div>

      {/* Model Compatibility Section */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Vehicle Model Compatibility</h3>
        <p className="text-sm text-gray-500 mb-4">
          Add vehicle models this part is compatible with. Models will be loaded based on selected brands.
        </p>

        {(!formData.brands || formData.brands.length === 0) && (
          <div className="mb-4 p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <div className="flex items-center">
              <svg className="h-5 w-5 text-amber-400 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              <span className="text-sm text-amber-800">Please select at least one brand first to see compatible models.</span>
            </div>
          </div>
        )}

        {modelsLoading && (
          <div className="mb-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
            <div className="flex items-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
              </svg>
              <span className="text-sm text-blue-800">Loading available models...</span>
            </div>
          </div>
        )}

        {modelCompatibility.map((model, index) => (
          <div key={index} className="flex items-center mb-3">
            <div className="flex-grow relative" ref={index === activeModelIndex ? modelSearchRef : null}>
              <input
                type="text"
                value={model}
                onChange={(e) => handleModelChange(index, e.target.value)}
                onFocus={() => {
                  if (!formData.brands || formData.brands.length === 0) {
                    alert('Please select at least one brand first to see compatible models.');
                    return;
                  }
                  setActiveModelIndex(index);
                  setModelSearch(model);

                  const filteredModels = model.length > 0
                    ? computedAvailableModels.filter(m =>
                      m.name.toLowerCase().includes(model.toLowerCase())
                    )
                    : computedAvailableModels;

                  setModelSuggestions(filteredModels);
                  setShowModelSuggestions(filteredModels.length > 0);
                }}
                className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
                placeholder={formData.brands && formData.brands.length > 0 ? "Start typing to search vehicle models..." : "Select brands first"}
                autoComplete="off"
                disabled={!formData.brands || formData.brands.length === 0 || modelsLoading}
              />

              {showModelSuggestions && modelSuggestions.length > 0 && index === activeModelIndex && (
                <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                  {modelSuggestions.map((suggestion, suggestionIndex) => (
                    <div
                      key={suggestionIndex}
                      className="cursor-pointer select-none relative py-2 pl-3 pr-9 hover:bg-orange-50 hover:text-orange-900"
                      onClick={() => handleModelSuggestionSelect(suggestion, index)}
                    >
                      <div className="flex items-center justify-between">
                        <span className="font-normal block truncate">
                          {suggestion.name}
                        </span>
                        {suggestion.brandName && (
                          <span className="text-xs text-gray-500 ml-2">
                            {suggestion.brandName}
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              type="button"
              className="ml-2 p-2 text-red-600 hover:text-red-900"
              onClick={() => handleRemoveModel(index)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          </div>
        ))}

        <Button
          type="button"
          variant="secondary"
          onClick={handleAddModel}
          className="mt-2"
          disabled={!formData.brands || formData.brands.length === 0 || modelsLoading}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>
          Add Compatible Vehicle Model
        </Button>

        {formData.brands && formData.brands.length > 0 && computedAvailableModels.length > 0 && (
          <div className="mt-4 p-3 bg-blue-50 rounded-lg">
            <p className="text-sm font-medium text-blue-800 mb-2">
              Available models for selected brands ({computedAvailableModels.length} total):
            </p>
            <div className="flex flex-wrap gap-1 text-xs">
              {computedAvailableModels.slice(0, 8).map((model, index) => (
                <span key={index} className="inline-flex items-center px-2 py-1 rounded bg-blue-100 text-blue-700">
                  {model.name}
                  {model.brandName && (
                    <span className="ml-1 text-blue-500">({model.brandName})</span>
                  )}
                </span>
              ))}
              {computedAvailableModels.length > 8 && (
                <span className="inline-flex items-center px-2 py-1 rounded bg-blue-100 text-blue-700">
                  +{computedAvailableModels.length - 8} more
                </span>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Pricing & Inventory Section */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Pricing & Inventory</h3>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-1">
          <Input
            label="Selling Price (₹)"
            id="price"
            name="price"
            type="number"
            step="0.01"
            min="0"
            value={formData.price || ''}
            onChange={handleChange}
            error={errors.price}
            placeholder="0.00"
          />


        </div>

 <div className="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
  <Input
    label="Stock Quantity"
    id="stock"
    name="stock"
    type="number"
    min="0"
    value={formData.stock || ''}
    onChange={handleChange}
    error={errors.stock}
    placeholder="0"
    className="appearance-none"
  />

  <Input
    label="Reorder Level"
    id="reorderLevel"
    name="reorderLevel"
    type="number"
    min="0"
    value={formData.reorderLevel || ''}
    onChange={handleChange}
    error={errors.reorderLevel}
    placeholder="10"
    className="appearance-none"
  />
</div>
      </div>

      {/* Product Images Section */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Product Images</h3>
        <p className="text-sm text-gray-500 mb-4">
          Upload images of your product. You can upload multiple images. Supported formats: JPG, PNG, GIF (max 10MB each).
        </p>

        <div className="flex items-center justify-center p-6 border-2 border-gray-300 border-dashed rounded-md hover:border-orange-400 transition-colors">
          <div className="space-y-1 text-center">
            <svg
              className="mx-auto h-12 w-12 text-gray-400"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 48 48"
              aria-hidden="true"
            >
              <path
                d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="flex text-sm text-gray-600">
              <label
                htmlFor="file-upload"
                className="relative cursor-pointer bg-white rounded-md font-medium text-orange-600 hover:text-orange-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-orange-500"
              >
                <span>Upload files</span>
                <input
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  className="sr-only"
                  accept="image/*"
                  multiple
                  onChange={(e) => handleImageUpload(e.target.files)}
                />
              </label>
              <p className="pl-1">or drag and drop</p>
            </div>
            <p className="text-xs text-gray-500">
              PNG, JPG, GIF up to 10MB each
            </p>
          </div>
        </div>

        {imagePreviewUrls.length > 0 && (
          <div className="mt-6">
            <h4 className="text-sm font-medium text-gray-700 mb-3">
              Product Images ({imagePreviewUrls.length})
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
              {imagePreviewUrls.map((url, index) => {
                const existingImagesCount = isEdit ? (initialData?.imageUrls?.length || 0) : 0;
                const isExistingImage = isEdit && index < existingImagesCount;
                const isRemovedImage = removedImageIndexes.includes(index);

                return (
                  <div key={index} className={`relative ${isRemovedImage ? 'opacity-50' : ''}`}>
                    <div className="aspect-w-1 aspect-h-1 rounded-md overflow-hidden group">
                      <img
                        src={url}
                        alt={`Product image ${index + 1}`}
                        className="object-cover w-full h-32 rounded-md"
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextElementSibling.style.display = 'flex';
                        }}
                      />
                      <div className="hidden w-full h-32 bg-gray-200 rounded-md items-center justify-center">
                        <svg className="h-8 w-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                      </div>
                      <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                        <button
                          type="button"
                          className="p-1 rounded-full bg-red-500 text-white hover:bg-red-600 transition-colors"
                          onClick={() => handleImageRemove(index)}
                          title={isRemovedImage ? 'Restore image' : 'Remove image'}
                        >
                          {isRemovedImage ? (
                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                            </svg>
                          ) : (
                            <svg className="h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          )}
                        </button>
                      </div>
                    </div>
                    <p className="text-xs text-gray-500 mt-1 text-center">
                      {isExistingImage
                        ? isRemovedImage
                          ? 'Will be removed'
                          : 'Existing'
                        : 'New'
                      }
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* Specifications Section */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Product Specifications</h3>
        <p className="text-sm text-gray-500 mb-4">
          Add specifications to provide additional details about your product.
        </p>

        {specifications.map((spec, index) => (
          <div key={index} className="grid grid-cols-1 gap-4 sm:grid-cols-2 mb-4">
            <Input
              label={`Specification Name ${index + 1}`}
              id={`spec-name-${index}`}
              value={spec.name}
              onChange={(e) => handleSpecificationChange(index, 'name', e.target.value)}
              placeholder="e.g. Material, Size, Color, Torque"
            />

            <div className="flex items-end">
              <div className="flex-grow">
                <Input
                  label={`Specification Value ${index + 1}`}
                  id={`spec-value-${index}`}
                  value={spec.value}
                  onChange={(e) => handleSpecificationChange(index, 'value', e.target.value)}
                  placeholder="e.g. Aluminum, Large, Red, 45 Nm"
                />
              </div>
              <button
                type="button"
                className="ml-2 p-2 text-red-600 hover:text-red-900 mb-1"
                onClick={() => handleRemoveSpecification(index)}
                title="Remove specification"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        ))}

        <Button
          type="button"
          variant="secondary"
          onClick={handleAddSpecification}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
          </svg>
          Add Specification
        </Button>
      </div>

      {/* Physical Properties */}
      {/* <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Physical Properties</h3>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-4">
          <Input
            label="Weight (kg)"
            id="weight"
            name="weight"
            type="number"
            step="0.01"
            min="0"
            value={formData.weight || ''}
            onChange={handleChange}
            error={errors.weight}
            placeholder="0.0"
          />

          <Input
            label="Length (cm)"
            id="dimensions.length"
            name="dimensions.length"
            type="number"
            step="0.1"
            min="0"
            value={formData.dimensions?.length || ''}
            onChange={handleChange}
            error={errors['dimensions.length']}
            placeholder="0.0"
          />

          <Input
            label="Width (cm)"
            id="dimensions.width"
            name="dimensions.width"
            type="number"
            step="0.1"
            min="0"
            value={formData.dimensions?.width || ''}
            onChange={handleChange}
            error={errors['dimensions.width']}
            placeholder="0.0"
          />

          <Input
            label="Height (cm)"
            id="dimensions.height"
            name="dimensions.height"
            type="number"
            step="0.1"
            min="0"
            value={formData.dimensions?.height || ''}
            onChange={handleChange}
            error={errors['dimensions.height']}
            placeholder="0.0"
          />
        </div>
      </div> */}

      {/* Notes Section */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Additional Information</h3>

        <div>
          <label htmlFor="notes" className="block text-sm font-medium text-gray-700">
            Notes
          </label>
          <div className="mt-1">
            <textarea
              id="notes"
              name="notes"
              rows={4}
              className="shadow-sm focus:ring-orange-500 focus:border-orange-500 block w-full sm:text-sm border border-gray-300 rounded-md"
              value={formData.notes || ''}
              onChange={handleChange}
              placeholder="Additional remarks, installation position, special compatibility notes, maintenance instructions..."
            />
          </div>
        </div>

        <div className="mt-6">
          <Checkbox
            id="isActive"
            name="isActive"
            checked={formData.isActive !== false}
            onChange={handleChange}
            label="Product is active and available for sale"
          />
        </div>
      </div>

      {/* Form Actions */}
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        <div className="flex justify-end space-x-4">
          <Button
            type="button"
            variant="secondary"
            onClick={() => window.history.back()}
            disabled={submitting}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            disabled={submitting || loading}
          >
            {submitting ? (
              <div className="flex items-center">
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                </svg>
                Processing...
              </div>
            ) : (
              submitButtonText
            )}
          </Button>
        </div>
      </div>

      {/* Add Category Modal */}
      {showAddCategoryModal && (
        <div className="fixed z-50 inset-0 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Add New Category</h3>
                    <div className="space-y-4">
                      <Input
                        label="Category Name"
                        value={newCategory.name}
                        onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                        placeholder="Enter category name"
                        required
                      />
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                          rows={3}
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
                          value={newCategory.description}
                          onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                          placeholder="Category description (optional)"
                        />
                      </div>
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Category Image</label>
                        <input
                          type="file"
                          accept="image/*"
                          className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-700 hover:file:bg-orange-100"
                          onChange={(e) => setNewCategory({ ...newCategory, image: e.target.files[0] })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={handleAddCategory}
                >
                  Add Category
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setShowAddCategoryModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Brand Modal */}
      {showAddBrandModal && (
        <div className="fixed z-50 inset-0 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>

            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div className="sm:flex sm:items-start">
                  <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
                    <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Add New Brand</h3>
                    <div className="space-y-4">
                      <Input
                        label="Brand Name"
                        value={newBrand.name}
                        onChange={(e) => setNewBrand({ ...newBrand, name: e.target.value })}
                        placeholder="Enter brand name"
                        required
                      />
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                          rows={3}
                          className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm focus:ring-orange-500 focus:border-orange-500 sm:text-sm"
                          value={newBrand.description}
                          onChange={(e) => setNewBrand({ ...newBrand, description: e.target.value })}
                          placeholder="Brand description (optional)"
                        />
                      </div>
                      <Input
                        label="Website URL"
                        value={newBrand.website}
                        onChange={(e) => setNewBrand({ ...newBrand, website: e.target.value })}
                        placeholder="https://example.com (optional)"
                      />
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Brand Logo</label>
                        <input
                          type="file"
                          accept="image/*"
                          className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-orange-50 file:text-orange-700 hover:file:bg-orange-100"
                          onChange={(e) => setNewBrand({ ...newBrand, logo: e.target.files[0] })}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <button
                  type="button"
                  className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-orange-600 text-base font-medium text-white hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={handleAddBrand}
                >
                  Add Brand
                </button>
                <button
                  type="button"
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setShowAddBrandModal(false)}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default ProductForm;